// Author Liang Gang Qiang
// Date 2021-11-08 16:37:42

class MintalMesPrdPelletizingIngredientPlan {
constructor({
        id = null,
        code = '',
        locationId = '',
        locationName = '',
        beginTime = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.locationId = locationId;
    this.locationName = locationName;
    this.beginTime = beginTime;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdPelletizingIngredientPlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'beginTime',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.beginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdTime',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByName',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.createdByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '新创建' },
                            { value: '2', text: '经复制' },
                            { value: '3', text: '已保存' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    locationIdFilter : '',
    locationNameFilter : '',
    beginTimeRteFilter : '',
    beginTimeLteFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'locationNameFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'beginTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.filter.beginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'beginTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.filter.beginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '新创建' },
                { value: '2', text: '经复制' },
                { value: '3', text: '已保存' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'beginTime',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.entity.beginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlan.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdPelletizingIngredientPlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
